import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { NumberDisplayList, ProgressCircle, StationCard, UNIT } from "../..";
import { colors, css, glyphs } from "../../../Styles";
import { EsfLocation } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import PenList, { ListTypes } from "../../BaseComponents/Animals/penList";
import { System, Location, Graph_QL } from "../../../Services";
import { useAppSelector } from "../../../Store";
import { NewButtonList } from "../../BaseComponents/newButton";

// TODO: testdata

interface sectionModal_Props {
  system: System;
  activeSectionId?: number;
  onStationSelected?: (stationId: number) => void;
  pen: Location[],
  stations: EsfLocation[];
}

export default function EsfSectionModal({activeSectionId, onStationSelected, stations, system }:sectionModal_Props) {
  const { t } = useTranslation()
  const [currentFeedview, setCurrentFeedview] = useState<"ANIMALS" | "STATIONS">("STATIONS");
  const [selectedPenNo, setSelectedPenNo] = useState<number | null>(null);

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const { domain, connection } = useMemo(() => {
    let domain = Graph_QL.ObjToString({ domain: farm });
    let connection = Graph_QL.create({ domain: farm });
    return { domain, connection };
  }, [farm]);
  
  // #region | Header Content
  // ProgressCircle: Remaining Today TODO
  const RemainingToday: JSX.Element = useMemo(() => {
    return (
      <ProgressCircle
        animation
        header={t("feed.general.remainingToday", {defaultValue: "remaining today"})}
        total={0}
        progressed={0}
        unit={<UNIT content={"Kg"} color={colors.greyPrimary} glyph={<glyphs.Kg size="15px" fillColor={colors.greyPrimary}/>}/>}
      />
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  // NumberDisplayList: Currently in this section TODO
  const FeedCorrections: JSX.Element = useMemo(() => {
    return (
      <div style={{height: "170px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: "18px"}}>
        <NumberDisplayList
          units={[
            "Stations",
            "Animals",
          ]}
          values={[
            0,
            0
          ]}
          header={"Currently in this section"}
        />
      </div>
    )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t])

  // Seperator Line
  const seperatorLine = (
    <div style={{width: "650px", display: "flex", alignItems: "center", justifyContent: "center", margin: "20px auto"}}>
      <div style={{width: "600px", height: "2px", backgroundColor: colors.greyTertiary}}/>
    </div>
  );

  const StationClick = (stationId: number) => {
    if (onStationSelected) {
      onStationSelected(stationId);
    }
  }
  // #endregion

  // #region | Feed View State Router
  const FeedviewStateRouter = () => {
    switch (currentFeedview) {
      case "ANIMALS":
        return (
          <div style={{ }}>
            <PenList listType={ListTypes.pens} headerPen={true} systemType={system.fk_system_types} pens={stations}  connect={{connection: connection, farm: farm, domain: domain}}/>
          </div>
        );
      case "STATIONS":
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", padding: "20px 0px 0px 0px"}}>
            {stations.map((station) => 
              <StationCard key={station.location_id} station={station} onClick={() => StationClick(station.location_id)}/>
            )}
          </div>
        );
      default:
        return null;
    }
  }
  // #endregion
  
  return (<>
    <div style={{ ...css.modalTop }}>
      {RemainingToday}
      {FeedCorrections}
    </div>
    {seperatorLine}
    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center"}}>
      <NewButtonList
        contents={[
          "Stations",
          "Animals",
        ]}
        onClick={(i) => {
          if (i === 0) {setCurrentFeedview("STATIONS")}
          if (i === 1) {setCurrentFeedview("ANIMALS")}
        }}
        overrides={{baseStyles: { ...css.button_FitContent }}}
      />
      {FeedviewStateRouter()}
    </div>
  </>)
}